import RouteName from '@/models/enums/RouteName'

export default [
  {
    path: '/delivery-zones',
    name: RouteName.DeliveryZones,
    component: () => import('@/pages/DeliveryZones/DeliveryZonesPage.vue'),
    meta: {
      permissions: ['crm.delivery-zones.view'],
      layout: 'StatisticCleanLayout',
      breadcrumb: {
        label: 'Зоны доставки и тарифы',
        parent: RouteName.Directory,
      },
    },
  },
]
